import { render, staticRenderFns } from "./siteRank.vue?vue&type=template&id=3bea970c&scoped=true&"
import script from "./siteRank.vue?vue&type=script&lang=js&"
export * from "./siteRank.vue?vue&type=script&lang=js&"
import style0 from "./siteRank.vue?vue&type=style&index=0&id=3bea970c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea970c",
  null
  
)

export default component.exports